import type { ApolloCache } from '@apollo/client'
import type { ConsumerDetailsFragment } from '../generated/graphql'
import { useAuthStore } from '../store/auth'

/** Apply Core's resolved currency after an address change, including cached display rates. */
export function syncConsumerCurrency(
  cache: ApolloCache<unknown>,
  consumer: Pick<ConsumerDetailsFragment, '_id' | 'currency'> | null | undefined,
): void {
  const session = useAuthStore.getState()
  if (!consumer?.currency || consumer._id !== session.consumerId || consumer.currency === session.config.currency) return

  // The conversion query is keyed by consumer/input, so its arguments do not change when the
  // customer's target currency changes. Evict every cached amount before updating the display.
  cache.evict({ id: 'ROOT_QUERY', fieldName: 'ConvertCurrencyForConsumer' })
  session.mergeConfig({ currency: consumer.currency })
}
